export const isTokenExpired = (token) => {
    try {
        const tokenParts = JSON.parse(atob(token.split('.')[1]));
        const now = Math.ceil(Date.now() / 1000);
        return tokenParts.exp < now;
    } catch {
        return undefined
    }
}